import React from 'react';
import ComingSoon from './ComingSoon';

const Chance = ({ block }) => {
  if (!block.text) return <ComingSoon />;

  return (
    <div
      className={`chance chance-${block.text}`}
      style={{
        textTransform: 'capitalize',
      }}
    >
      {block?.text?.split('-').join(' ')}
    </div>
  );
};

export default Chance;
